"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UINotificationBadge = _interopRequireDefault(require("UIComponents/badge/UINotificationBadge"));

var _default = (0, _createReactClass.default)({
  displayName: "Placeholder",
  propTypes: {
    conversations: _propTypes.default.instanceOf(_immutable.Map).isRequired,
    index: _propTypes.default.string.isRequired,
    selectConversationBlock: _propTypes.default.func
  },
  selectBlock: function selectBlock() {
    this.props.selectConversationBlock(this.props.index);
  },
  renderIndicator: function renderIndicator() {
    var conversationUpdates = this.props.conversations.reduce(function (acc, c) {
      return acc + c.updates;
    }, 0);

    var iconElement = _react.default.createElement(_UIIcon.default, {
      name: "comments"
    });

    if (conversationUpdates < 1) {
      return iconElement;
    }

    return _react.default.createElement(_UINotificationBadge.default, {
      badgeClassName: "unread-indicator-placeholder",
      badgeDescription: "new comments",
      badgeLabel: conversationUpdates,
      size: "small"
    }, iconElement);
  },
  render: function render() {
    return _react.default.createElement("div", {
      className: "conversations-placeholder pointer",
      onClick: this.selectBlock
    }, _react.default.createElement("div", {
      className: "conversations-wrapper-header"
    }, this.renderIndicator()));
  }
});

exports.default = _default;
module.exports = exports.default;